import apiPdca from '../../../../helpers/apiPdca'
import { AddAlert } from '../../../../components'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const STRATEGIC_CONTEXT_FETCH_REQUEST = 'STRATEGIC_CONTEXT_FETCH_REQUEST'
export const STRATEGIC_CONTEXT_FETCH_SUCCESS = 'STRATEGIC_CONTEXT_FETCH_SUCCESS'
export const STRATEGIC_CONTEXT_FETCH_FAILURE = 'STRATEGIC_CONTEXT_FETCH_FAILURE'

export const STRATEGIC_CONTEXT_SAVE_REQUEST = 'STRATEGIC_CONTEXT_SAVE_REQUEST'
export const STRATEGIC_CONTEXT_SAVE_SUCCESS = 'STRATEGIC_CONTEXT_SAVE_SUCCESS'
export const STRATEGIC_CONTEXT_SAVE_FAILURE = 'STRATEGIC_CONTEXT_SAVE_FAILURE'

export const STRATEGIC_CONTEXT_UPDATE_FIELD = 'STRATEGIC_CONTEXT_UPDATE_FIELD'
export const STRATEGIC_CONTEXT_CLEAR = 'STRATEGIC_CONTEXT_CLEAR'

const normalizarValor = valor => {
  if (valor === null || valor === undefined) return ''
  return String(valor)
}

const normalizarPayload = data => ({
  posicionamento: normalizarValor(data?.posicionamento),
  restricoes: normalizarValor(data?.restricoes),
  prioridades: normalizarValor(data?.prioridades)
})

const paraNullSeVazio = valor => {
  const texto = String(valor || '').trim()
  return texto ? texto : null
}

export const fetchStrategicContext = projetoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nls = require(`../nls/${sistema.idioma}.json`)

    dispatch({ type: STRATEGIC_CONTEXT_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get('/pdca/obtercontextoestrategicopdca', {
        params: { projetoId }
      })

      const data = response?.data || {}

      dispatch({
        type: STRATEGIC_CONTEXT_FETCH_SUCCESS,
        payload: normalizarPayload(data)
      })
    } catch (error) {
      dispatch({
        type: STRATEGIC_CONTEXT_FETCH_FAILURE,
        payload: nls.loadError
      })

      dispatch(AddAlert('danger', nls.loadError))
    } finally {
      dispatch(loaded())
    }
  }
}

export const saveStrategicContext = ({
  projetoId,
  posicionamento,
  restricoes,
  prioridades
}) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nls = require(`../nls/${sistema.idioma}.json`)

    dispatch({ type: STRATEGIC_CONTEXT_SAVE_REQUEST })
    dispatch(loading())

    try {
      const body = {
        posicionamento: paraNullSeVazio(posicionamento),
        restricoes: paraNullSeVazio(restricoes),
        prioridades: paraNullSeVazio(prioridades)
      }

      await apiPdca.post(`/pdca/gravarcontextoestrategicopdca/${projetoId}`, body)

      dispatch({
        type: STRATEGIC_CONTEXT_SAVE_SUCCESS,
        payload: body
      })

      dispatch(AddAlert('success', nls.saveSuccess))
    } catch (error) {
      dispatch({
        type: STRATEGIC_CONTEXT_SAVE_FAILURE,
        payload: nls.saveError
      })

      dispatch(AddAlert('danger', nls.saveError))
    } finally {
      dispatch(loaded())
    }
  }
}

export const updateStrategicContextField = (field, value) => ({
  type: STRATEGIC_CONTEXT_UPDATE_FIELD,
  payload: {
    field,
    value
  }
})

export const clearStrategicContext = () => ({
  type: STRATEGIC_CONTEXT_CLEAR
})